import Swiper from "swiper/swiper-bundle";

var screencheck = function (mediasize) {
    if (typeof window.matchMedia !== "undefined") {
        var screensize = window.matchMedia("(max-width:" + mediasize + "px)");
        if (screensize.matches) {
            return true;
        } else {
            return false;
        }
    } else { // for IE9 and lower browser
        if ($winW() <= mediasize) {
            return true;
        } else {
            return false;
        }
    } 
};



$(document).ready(function(){
/*--------------------------------------------------------------------------------------------------------------------------------------*/
    $("html").removeClass('no-js').addClass('js');


    /* Header Sticky
		---------------------------------------------------------------------*/
    if ($("#header").length) {
        $(window).scroll(function () {
            var headerHeight = $('#header').outerHeight()-42;
            if ($(this).scrollTop() > headerHeight) {
                $("#header").addClass("sticky");
            } else {
                $("#header").removeClass("sticky");
            }
            if ($(this).scrollTop() > headerHeight+40) {
                $("#header").addClass("top");
            } else {
                $("#header").removeClass("top");
            }
        });
    }


    /* Menu ICon Append prepend for responsive
		---------------------------------------------------------------------*/
    $(window).on('resize', function(){
        if (screencheck(991)) {
            if(!$('#menu').length){
                $('#mainmenu').prepend('<a href="#" id="menu" class="menulines-button"><span class="menulines"></span></a>');
            }
        } else {
            $("#menu").remove();
        }
    }).resize();

    /* Mobile menu click
		---------------------------------------------------------------------*/
    $(document).on('click', "#menu", function () {
        $(this).toggleClass('menuopen');
        $(this).next('ul').slideToggle('normal');
        return false;
    });


    function toggleModal() {
        const modal = $('.modal');
        const closeBtn = $('[data-modal-close]');
        const openBtn = $('[data-trigger-modal]');


        function openModal(elem) {
            let target = $(elem.currentTarget).attr("data-trigger-modal") || elem.attr("data-trigger-modal")
            let modal = $(`[data-modal="${target}"]`);
            
            modal.fadeIn(100,function() {
                modal.addClass('open')
            })
            
            $('body').addClass("modal-open")

            return false;
        }

        openBtn.on("click", openModal)
        
        function closeModal() {
            modal.fadeOut(300);
            $('body').removeClass("modal-open");

            modal.removeClass("open");
            return false;
        }
        closeBtn.on("click",closeModal);

    }
    toggleModal();


    /* Tab Content box  ---------------------------------------------------------------------*/
    var tabBlockElement = $('.tab-data');
        $(tabBlockElement).each(function() {
            var $this = $(this),
                tabTrigger = $this.find(".tabnav li"),
                tabContent = $this.find(".tabcontent");
                var textval = [];
                tabTrigger.each(function() {
                    textval.push( $(this).text() );
                });	
            $this.find(tabTrigger).first().addClass("active");
            $this.find(tabContent).first().show();

            $(tabTrigger).on('click',function () {
                $(tabTrigger).removeClass("active");
                $(this).addClass("active");
                $(tabContent).hide().removeClass('visible');
                var activeTab = $(this).find("a").attr("data-rel");
                $this.find('#' + activeTab).fadeIn('normal').addClass('visible');
                            
                return false;
            });
        
            var responsivetabActive =  function(){
            if (screencheck(767)){
                if( !$this.find('.tabMobiletrigger').length ){
                    $(tabContent).each(function(index) {
                        $(this).wrap("<div class='accordion'></div>")
                        $(this).before("<h5 class='tabMobiletrigger'>"+textval[index]+"</h5>");	
                        $this.find('.tabMobiletrigger:first').addClass("rotate");
                    });
                    $('.tabMobiletrigger').click('click', function(){
                        var tabAcoordianData = $(this).next('.tabcontent');
                        if($(tabAcoordianData).is(':visible') ){
                            $(this).removeClass('rotate');
                            $(tabAcoordianData).slideUp('normal');
                            //return false;
                        } else {
                            $this.find('.tabMobiletrigger').removeClass('rotate');
                            $(tabContent).slideUp('normal');
                            $(this).addClass('rotate');
                            $(tabAcoordianData).not(':animated').slideToggle('normal');
                        }
                        return false;
                    });
                }
                    
            } else {
                if( $('.tabMobiletrigger').length ){
                    $('.tabMobiletrigger').remove();
                    tabTrigger.removeClass("active");
                    $this.find(tabTrigger).removeClass("active").first().addClass('active');
                    $this.find(tabContent).hide().first().show();				
                }		
            }
        };
        $(window).on('resize', function(){
            if(!$this.hasClass('only-tab')){
                responsivetabActive();
            }
        }).resize();
    });


    /* Accordion box JS
    ---------------------------------------------------------------------*/
    $('.accordion-databox').each(function() {
        var $accordion = $(this),
            $accordionTrigger = $accordion.find('.accordion-trigger'),
            $accordionDatabox = $accordion.find('.accordion-data');
            
            $accordionTrigger.first().addClass('open');
            $accordionDatabox.first().show();
            
            $accordionTrigger.on('click',function (e) {
                var $this = $(this);
                var $accordionData = $this.next('.accordion-data');
                if( $accordionData.is($accordionDatabox) &&  $accordionData.is(':visible') ){
                    $this.removeClass('open');
                    $accordionData.slideUp(400);
                    e.preventDefault();
                } else {
                    $accordionTrigger.removeClass('open');
                    $this.addClass('open');
                    $accordionDatabox.slideUp(400);
                    $accordionData.slideDown(400);
                }
            });
    });
		


    // tabnav line navgation
    $(".tabnav li a").on("click",function() {
        let width = $(this)[0].offsetWidth;
        let left = $(this)[0].offsetLeft;

        $(this).parents(".tabnav").css({"--width": width+"px", "--left": left+"px"})
    })
    
    // swiper js
    // banner Swiper
    if($(".segment-swiper").length){
        var segmentSwiper = new Swiper(".segment-swiper", {
            grabCursor:true,
            slidesPerView: 1,
            spaceBetween: 20,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: ".segment-swiper-navigation .swiper-button-next",
                prevEl: ".segment-swiper-navigation .swiper-button-prev",
            },
            breakpoints: {
                568: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
        });      
    }

    if($(".products-swiper").length){
        const productsSwiper = new Swiper(".products-swiper", {
            grabCursor:true,
            slidesPerView: 1,
            autoHeight: true,
            effect: "creative",
            creativeEffect: { 
                 prev: {
                    translate: ['-100%',0,0],
                    scale: 0.5,
                    opacity: 0
                },
                next: {
                    translate: ['95%',0,0],
                    scale: 0.79,
                },
                limitProgress: 2
            },
            breakpoints:{
                768: {
                    autoHeight: false,
                }
            },
            navigation: {
                nextEl: ".product-swiper-navigation .swiper-button-next",
                prevEl: ".product-swiper-navigation .swiper-button-prev",
            },
             on: {
                init: function () {
                    if(this.slides.length <= this.slidesPerViewDynamic()){
                        console.log($(this.navigation.$nextEl)[0]);
                        $(this.navigation.$nextEl)[0].classList.add("disabled");
                        $(this.navigation.$prevEl)[0].classList.add("disabled");
                    }
                }
            }
        });
    }

    // floting box toggle 

    // const floating_box_open_btn = $(".floating-box .toggle-btn");
    const floating_box_toggle_btn = $(".floating-box .toggle-btn i");
    const floating_box = $(".floating-box .floating-box-content");
    let isOpen = false;

    floating_box_toggle_btn.on("click",function(e) {
        e.stopPropagation()
        let isTransitionEnd = false;

        if(!isOpen){
            isOpen = true
            $(".floating-box").addClass("open")
            $(".floating-box")[0].addEventListener("transitionend",(e)=>{
                e.stopPropagation()
                if(!isTransitionEnd){
                    isTransitionEnd = true;
                    floating_box.slideDown(300)
                }
            })
        }else{
            isOpen = false
            floating_box.slideUp(300,function() {
                $(".floating-box").removeClass("open")
            })
        }
        return false;
    })


    // our transport swiper
    if($(".our-transport-swiper").length){
        var transportSwiper = new Swiper(".our-transport-swiper", {
            grabCursor:true,
            slidesPerView: 1,
            spaceBetween: 20,
            breakpoints: {
                374: {
                    slidesPerView: 1,
                },
                568: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
            navigation: {
                nextEl: ".transport-swiper-navigation .swiper-button-next",
                prevEl: ".transport-swiper-navigation .swiper-button-prev",
            },
        });      
        
       
    }
    // more news swiper
    if($(".more-news-swiper").length){
        var morenewsSwiper = new Swiper(".more-news-swiper", {
            grabCursor:true,
            slidesPerView: 1,
            spaceBetween: 20,
            // grid: {
            //     rows: 2
            // },
            breakpoints: {
                374: {
                    slidesPerView: 1,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
        });      
    }

    let hovermenutimeout; 
	function hoverMenu(e) {
		if(screencheck(992)){
			return
		}
		let $this = $(e.currentTarget)
		let menu = $this.children(".inner-menu")
		if(e.type === "mouseenter"){
            $this.siblings("li").find(".inner-menu").fadeOut(200).removeClass("active");
            $this.addClass("active")
			menu.fadeIn(200,function () {
				menu.addClass("active")
			})
			clearTimeout(hovermenutimeout)
		}else if(e.type === "mouseleave"){
			hovermenutimeout = setTimeout(() => {
				menu.fadeOut(200, function () {
					menu.removeClass("active");
					$this.removeClass("active")
				});
			}, 200);			
		}
		return false
	}
	$("#mainmenu>ul>li.has-menu").hover(hoverMenu)

    $(window).on('resize',function() {
        if(screencheck(991)){
            if(!$(".sub-menu-toggle").length){
                $('#mainmenu > ul > li.has-menu').append("<span class='sub-menu-toggle'></span>")
                toggleMenu()
            }
        }else{
            if($(".sub-menu-toggle").length){
                $(".sub-menu-toggle").remove()
                $('#mainmenu>ul').css('display', '')
                $('.inner-menu').css('display', '')
                $('.has-menu').removeClass('active')
            }
        }
    }).resize()

    function toggleMenu() {
        $("#mainmenu>ul>li.has-menu .sub-menu-toggle").on("click",function() {
            $(this).parent('.has-menu').toggleClass('active').siblings('.has-menu').removeClass('active')
            $(this).siblings('.inner-menu').slideToggle(200).parents('.has-menu').siblings('.has-menu').find('.inner-menu').slideUp(200)
            return false;
        })
    }


    
    $(window).on('resize',function() {
        if(screencheck(575)){
            $('.contact-block').find('.contact-info figure').appendTo('.contact-block .section-title');
        } else {
            $('.contact-block .section-title').find('figure').appendTo(".contact-info .col:last");
            
            
        }
    }).resize();
    

/*--------------------------------------------------------------------------------------------------------------------------------------*/
})



